<div class="corridor-padding">
    <svg width="990" height="500" id="svg6">
    </svg>
    </div>